export const getMaxValueFromMetrics = <T extends Record<string, unknown>>(
  data: T[],
  metricsConfig: Record<string, unknown>,
  hiddenMetrics: Set<string> = new Set()
): number => {
  const allValues = data.flatMap((item) =>
    Object.entries(metricsConfig)
      .filter(([key]) => !hiddenMetrics.has(key))
      .map(([key]) => (item as unknown as Record<string, number>)[key] || 0)
  )
  return Math.max(...allValues, 0)
}

export const getMaxValueFromData = <T>(data: T[], key: string): number => {
  return Math.max(...data.map((item) => ((item as Record<string, unknown>)[key] as number) || 0), 0)
}

/**
 * Calculate dynamic YAxis width based on the maximum value in the data
 *
 * @param maxValue - Maximum value that will be displayed on the Y axis
 * @returns Width in pixels for the YAxis component
 *
 * @example
 * calculateYAxisWidth(999)      // 60px  (3 digits)
 * calculateYAxisWidth(9999)     // 60px  (4 digits)
 * calculateYAxisWidth(10000)    // 70px  (5 digits)
 * calculateYAxisWidth(153732)   // 80px  (6 digits)
 * calculateYAxisWidth(1000000)  // 90px  (7 digits)
 */
export const calculateYAxisWidth = (maxValue: number): number => {
  const digitCount = maxValue.toString().length

  return digitCount <= 4 ? 60 : 60 + (digitCount - 4) * 10
}
